export default __webpack_public_path__ + "static/7aa-a8fa6dd08896ccef13a287ddfe74f903.png";